
const config = {
  apiEndpoint: "http://localhost:3300/v1",
  scraperEndpoint: "https://scraper.shorby.dev",
  lightningHost: "https://shor.dev",
  actionCableEndpoint: "wss://api.shorby.dev/cable",
  stripePK: "pk_test_EObdW3IEDsXNILNQ72sgW0Pg",
  filestackKey: "ACu6zRr4STeUW5lt46U5Qz"
};

export default config;


// WEBPACK FOOTER //
// ./src/config/development.js